<template>
  <div>
    <v-dialog v-model="dialog" max-width="750px">
      <div class="panel-body">
        <v-card>
          <v-card-title>
            <span class="headline">Upload Report</span>
          </v-card-title>
          <v-container>
            <v-row class="px-2">
              <v-col>
                <v-text-field
                  v-model="newReport.description"
                  label="Report display name"
                  single-line
                  hide-details
                  clearable
                  hint
                  persistent-hint="ex: May 2019"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="px-2">
              <v-col>
                <v-menu
                  v-model="preparedForDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="newReport.preparedForDate"
                      label="Prepared For Date"
                      append-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newReport.preparedForDate"
                    @input="preparedForDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="px-2">
              <v-col>
                <v-file-input
                  v-model="newReport.userReport"
                  accept="application/pdf"
                  label="User Report"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>

            <v-btn
              color="blue darken-1"
              text
              @click="uploadDocument"
              :disabled="!newReport || !newReport.description || !newReport.userReport || !newReport.typeId || !newReport.preparedForDate"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col>
            <v-layout justify-end>
              <v-btn txt @click="openUploadReport">Upload Report</v-btn>
            </v-layout>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="reports"
        :search="search"
        item-key="id"
        class="elevation-1"
        @click:row="selectReport($event)"
      >
        <template v-slot:item.archived="{ item }">
          <v-layout justify-center>
            <v-switch v-model="item.archived" readonly></v-switch>
          </v-layout>
        </template>
        <template v-slot:item.viewed="{ item }">
          <v-layout justify-center>
            <v-switch v-model="item.viewed" readonly></v-switch>
          </v-layout>
        </template>
        <template slot="no-data"></template>
      </v-data-table>
      <v-overlay v-if="loadingDoc">
        <v-progress-circular v-if="loadingDoc" :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
let rh = require('@/components/APIs/RequestHandler')
export default {
  props: {
    user: {
      required: true
    }
  },
  data: () => ({
    reports: [],
    preparedForDateMenu: false,
    loadingDoc: false,
    selected: null,
    search: null,
    imgSrc: null,
    dialog: false,
    headers: [
      {
        text: 'Report ID',
        value: 'id'
      },
      { text: 'Type', value: 'typeId' },
      { text: 'Name', value: 'name' },
      { text: 'Description', value: 'description' },
      { text: 'Date', value: 'preparedForDate' },
      { text: 'Archived', value: 'archived', align: 'center' },
      { text: 'Archived Date', value: 'archivedDate' },
      { text: 'Viewed', value: 'viewed', align: 'center' },
      { text: 'Viewed Date', value: 'viewedDate' }
    ],
    newReport: null,
    defaultNewReport: {
      description: '',
      preparedForDate: null,
      typeId: 4,
      userReport: null
    }
  }),
  created () {
    this.loadReports()
    this.newReport = JSON.parse(JSON.stringify(this.defaultNewReport))
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadReports()
      }
    }
  },
  methods: {
    async selectReport (a) {
      this.loadingDoc = true
      this.selected = [a]
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/document/${
        a.id
      }`

      // console.log(endpoint)
      var getResponse = await rh.default.getBlob(endpoint, true).catch(e => {
        this.errors.push(e)
        this.loadingDoc = false
      })
      if (getResponse && getResponse.data) {
        // this.imgSrc = URL.createObjectURL(getResponse.data)
        const link = document.createElement('a')
        link.href = URL.createObjectURL(getResponse.data)
        // Automatically Download
        link.setAttribute('download', a.name)
        // These 2 lines are to automatically open in a new tab
        // link.setAttribute('open', a.name) //or any other extension
        // link.setAttribute('target', "_blank")
        document.body.appendChild(link)
        link.click()
      }
      this.loadingDoc = false
    },

    async loadReports () {
      if (
        this.user == null ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        // console.log('User ID not set, unable to load reports')
        this.reports = []
        return
      }
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/document/user/${this.user.userId}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (!getResponse || !getResponse.data) {
        this.reports = []
      } else {
        this.reports = getResponse.data
      }
    },
    openUploadReport () {
      this.newReport = JSON.parse(JSON.stringify(this.defaultNewReport))
      this.dialog = true
    },
    async uploadDocument () {
      this.loadingDoc = true
      let formData = new FormData()
      formData.append('document', this.newReport.userReport)
      const endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/document/user/${this.user.userId}/type/${
        this.newReport.typeId
      }?description=${this.newReport.description}&preparedForDate=${
        this.newReport.preparedForDate
      }`
      var postResponse = await rh.default
        .postFormData(endpoint, formData, true)
        .catch(e => {
          this.errors.push(e)
          this.loadingDoc = false
        })

      this.loadReports()
      this.loadingDoc = false
      this.dialog = false
    },
    close () {
      this.newReport = JSON.parse(JSON.stringify(this.defaultNewReport))
      this.dialog = false
    }
  }
}
</script>
